import { ReactElement } from 'react';
import { TextSize, Wrapper } from './Text.elements';

type TextProps = {
  children?:
    | string
    | ReactElement
    | number
    | Array<ReactElement | string | number>;
  size?: TextSize;
  tag?: 'section' | 'div' | 'span' | 'p';
};
export const Text = ({
  children,
  size = 'standard',
  tag = 'span',
}: TextProps): ReactElement => {
  return (
    <Wrapper $size={size} as={tag}>
      {children}
    </Wrapper>
  );
};
